export function formatMetadataDate(isoDate: string): string {
	const [year, month, day] = isoDate.split('-');
	if (!year || !month || !day) {
		return isoDate;
	}

	return `${day}.${month}.${year}`;
}

export function formatSharesYearQuarter(sharesYearQuarter: string): string {
	const match = sharesYearQuarter.match(/^(\d{4})Q(\d)$/);
	if (!match) {
		return sharesYearQuarter;
	}

	return `Q${match[2]} ${match[1]}`;
}
